import { faqSelectors } from '@sv-support-sdk/store';

export const {
  selectCategories,
  selectTopics,
  selectCategoriesLoading,
  selectTopicsLoading,
  categoryBySlugSelector,
  topicsByCategorySlugSelector,
  topicsLoadingByCategorySlugSelector,
  topicBySlugSelector,
} = faqSelectors;
